export const SUR_OBJECT_GET_REQUEST = 'SUR_OBJECT_GET_REQUEST';
export const SUR_OBJECT_GET_SUCCESS = 'SUR_OBJECT_GET_SUCCESS';
export const SUR_OBJECT_GET_ERROR = 'SUR_OBJECT_GET_ERROR';
export const SUR_OBJECT_GET_BY_KEY_REQUEST = 'SUR_OBJECT_GET_BY_KEY_REQUEST';
export const SUR_OBJECT_GET_BY_KEY_SUCCESS = 'SUR_OBJECT_GET_BY_KEY_SUCCESS';
export const SUR_OBJECT_GET_BY_KEY_ERROR = 'SUR_OBJECT_GET_BY_KEY_ERROR';
export const SUR_OBJECT_ADD_REQUEST = 'SUR_OBJECT_ADD_REQUEST';
export const SUR_OBJECT_ADD_SUCCESS = 'SUR_OBJECT_ADD_SUCCESS';
export const SUR_OBJECT_ADD_ERROR = 'SUR_OBJECT_ADD_ERROR';
export const SUR_OBJECT_EDIT_REQUEST = 'SUR_OBJECT_EDIT_REQUEST';
export const SUR_OBJECT_EDIT_SUCCESS = 'SUR_OBJECT_EDIT_SUCCESS';
export const SUR_OBJECT_EDIT_ERROR = 'SUR_OBJECT_EDIT_ERROR';
export const SUR_OBJECT_DELETE_REQUEST = 'SUR_OBJECT_DELETE_REQUEST';
export const SUR_OBJECT_DELETE_SUCCESS = 'SUR_OBJECT_DELETE_SUCCESS';
export const SUR_OBJECT_DELETE_ERROR = 'SUR_OBJECT_DELETE_ERROR';
